import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function NameSetup() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (user?.account_name) nav("/roster", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await api.post("/profile/set-name", { account_name: name.trim() });
      await refresh();
      nav("/roster", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to set name");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="card-surface p-8 max-w-md w-full" data-testid="name-setup-form">
        <h1 className="font-heading text-3xl mb-2 neon-cyan">PICK YOUR RING NAME</h1>
        <p className="text-[#A89BCC] mb-6 text-sm">This shows on leaderboards and show results.</p>
        <input
          data-testid="account-name-input"
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={24}
          placeholder="e.g. NEON_KING"
          className="w-full px-4 py-3 rounded-lg bg-[#0A051A] border border-[#FF007F]/40 focus:border-[#00F0FF] outline-none font-heading text-lg tracking-widest uppercase"
        />
        <button
          data-testid="submit-name-btn"
          disabled={busy || !name.trim()}
          className="btn-neon w-full mt-6"
        >
          {busy ? "SAVING..." : "ENTER THE RING"}
        </button>
      </form>
    </div>
  );
}
